
export default {
	name: 'ChatEmoji',
	methods: {
		clickButton(item) {
			this.$emit('mclick', item);
		},
	},
	data () {
		return {
            emojiList: ["😀","😃","😄","😁","😆","😅","🤣","😂","🙂","🙃","😉","😊","😇","😍","🤩","😘","😗","😚","😙","😋","😛","😜","🤪","😝","🤑","🤗","🤭","🤫","🤔","🤐","🤨","😐","😑","😶","😏","😬","🤥","😌","😔","😪","🤤","😴","😷","😵","🤯","🤠","😎","🤓","🧐","😟","🙁","😮","😯","😲","😳","😦","😧","😨","😰","😥","😢","😭","😱","🤡","👹","👻","👽","👾","🤖","😺","😸","😹","😻","😼","😽","🙀","😿","😾","🙈","🙉","🙊","💋","💌","💘","💝","💖","💗","💓","💞","💕","💟","🧡","💛","💚","💙","💜","🖤","💯","💫","💦","💨","💣","💬","💭","💤","👋","🤚","🖐","✋","🖖","👌","🤞","🤟","🤘","🤙","👈","👉","👆","👇","👍","✊","👊","🤛","🤜","👏","🙌","👐","🤲","🤝","🙏"],
		}
	},
}
